import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Title from '../../../components/Title';
import { useGetDataVendorUserQuery, useUpdateDataVendorUserMutation } from '../../../api/dataVendorUserApiSlice';
import FormButton from '../../../components/forms/FormButton';
import { DataVendorUserForm } from '../../../components/data_vendors/DataVendorUserForm';

export default function DataVendorUserEdit(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey: dataVendorId, userId } = useParams();
  const {data: user, isSuccess} = useGetDataVendorUserQuery({dataVendorId, userId})
  const [updateUser] = useUpdateDataVendorUserMutation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const goToUser = () => history.push(`/data_vendors/${dataVendorId}/users/${userId}`)

  const handleSubmit = (data) => {
    updateUser({dataVendorId, user: {...data, userId}}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  if (!isSuccess) { return (<></>) }
  return (
    <>
      <Title main={t("menu.users")} sub={`${user.firstName} ${user.lastName}`} group={false} onBack={goToUser}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToUser} />
      </Title>
      <DataVendorUserForm
        user={user}
        handleSubmit={handleSubmit}
        setSubmitButtonProps={setSubmitButtonProps}
        dataVendorId={dataVendorId}
        canSelectRole={true}
      />
    </>
  )
}




